<template>
  <header class="header">
    <a href="/" class="logo cursor-pointer">
      <img :src="require(`../../../../static/imgs/exhibition/logo.png`)" alt="logo">
    </a>
    <!-- <span @click="$href(toLink.link)" class="homeLink cursor-pointer">{{toLink.text}}</span> -->
    <lang class="login-header" />
  </header>
</template>

<script>
import lang from '../header/lang.vue'
/**
 * 接受index.vue 一个toLink参数，用以实现重置密码页面头部显示的文字为返回登录
 * 2017-09-06
 * by may */
export default {
  name: 'LoginHeader',
  components: { lang },
  props: {
    toLink: {
      type: Object,
      default() {
        return {
          text: 'pay'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  padding: 24px 40px;

  @media (max-width: 1200px) {
    padding: 24px;
  }

  .logo {
    width: 156px;

    > img {
      width: 100%;
      height: auto; /* Maintain aspect ratio */
    }

    @media (max-width: 720px) {
      width: 113px;
    }
  }

  .login-header {
    padding-top: 8px;

    @media (max-width: 720px) {
      padding-top: 0;
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }

  @media (max-width: 720px) {
    padding: 21px 16px;
  }
}
</style>
